"use client";
import React, { ReactNode } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

interface GoogleCaptchaWrapperProps {
  readonly children: ReactNode;
}

const GoogleCaptchaWrapper: React.FC<GoogleCaptchaWrapperProps> = ({
  children,
}: GoogleCaptchaWrapperProps) => {
  const recaptchaKey: string | undefined =
    process?.env?.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;

  return (
    <GoogleReCaptchaProvider reCaptchaKey={recaptchaKey ?? "NOT DEFINED"}>
      {children}
    </GoogleReCaptchaProvider>
  );
};

export default GoogleCaptchaWrapper;
